module.exports = __webpack_public_path__ + "static/flags/PL-197f4bbdeac830f8e9ecc31f3585cc4c.gif";